import { render, staticRenderFns } from "./CustomSolution.vue?vue&type=template&id=4a7ad126&scoped=true&"
import script from "./CustomSolution.vue?vue&type=script&lang=js&"
export * from "./CustomSolution.vue?vue&type=script&lang=js&"
import style0 from "./CustomSolution.vue?vue&type=style&index=0&id=4a7ad126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7ad126",
  null
  
)

export default component.exports